<template>
  <BottomSheet :show="show" :zIndex="9999" @close="$emit('close')">
    <!-- Overlapping icon -->
    <div class="flex justify-center -mt-12 mb-2">
      <div
        :class="[
          type === 'success'
            ? 'bg-green-500'
            : type === 'error'
            ? 'bg-red-500'
            : 'bg-blue-500',
          'rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white'
        ]"
      >
        <i
          :class="[
            type === 'success'
              ? 'bx bx-check-circle'
              : type === 'error'
              ? 'bx bx-x-circle'
              : 'bx bx-info-circle',
            'text-white text-4xl'
          ]"
        ></i>
      </div>
    </div>
    <!-- Card content -->
    <div class="px-6">
      <h2 class="text-2xl font-bold text-center mb-1">{{ title }}</h2>
      <p class="text-gray-500 text-center mb-4">{{ description }}</p>
      <div class="flex justify-center mt-4">
        <CuButton primary class="flex-1" @click="$emit('close')">Chiudi</CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "CuToastSheet",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false },
    type: { type: String, default: 'success' }, // 'success', 'error', or 'info'
    title: { type: String, required: true },
    description: { type: String, required: true }
  }
}
</script>
